import React from 'react'
import styles from "../css/LoadingButton.module.css"

const LoadingButton = ({deleting = false}) => {
  return (
    <div className = {`${styles.button} ${deleting ? styles.deleting : ""}`}>
        <div className = {styles.dot}></div>
        <div className = {styles.dot}></div>
        <div className = {styles.dot}></div>
    </div>
  )
}

export default LoadingButton